export default __webpack_public_path__ + "static/8524-60fb9cc47af44153782a9f9e1e690bf7.jpg";